export default __webpack_public_path__ + "static/media/luona_back.88e83dbf.jpg";